import HelpService from './service';
import { GetHelpStatus, HelpInquiryRouteParams, HelpInquirySummary } from './types';

export const HELP_QUERY_KEYS = {
  GET_HELP_STATUS: 'GET_HELP_STATUS',
  GET_HELP_INQUIRY_SUMMARY: 'GET_HELP_INQUIRY_SUMMARY',
};

export class HelpQueries {
  public static readonly getHelpStatus = async (): Promise<GetHelpStatus> => {
    const response = await HelpService.getHelpStatus();

    return response.data;
  };

  public static readonly getHelpInquirySummary = async (
    params: HelpInquiryRouteParams
  ): Promise<HelpInquirySummary> => {
    const response = await HelpService.getHelpInquirySummary(params);

    return response.data;
  };
}
